import React from 'react';
import PropTypes from 'prop-types';
// form
import { useForm, useWatch } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
// components
import { LoadingButton } from '@mui/lab';
import { Dialog, DialogTitle, Box, Button } from '@mui/material';
import { FormProvider, RHFTextField } from '../../../../../shared/components/hook-form';

// ----------------------------------------------------------------------

HelpModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  handleHelpRequest: PropTypes.func,
};

export default function HelpModal({ open, onClose, handleHelpRequest }) {
  const HelpSchema = Yup.object().shape({
    subject: Yup.string().required('Subject is required'),
    description: Yup.string()
      .required('Description is required')
      .max(250, 'Description must not be more than 250 characters'),
  });

  const methods = useForm({
    resolver: yupResolver(HelpSchema),
  });

  const {
    reset,
    handleSubmit,
    formState: { isSubmitting },
    control,
  } = methods;

  const subject = useWatch({ control, name: 'subject' });
  const description = useWatch({ control, name: 'description' });

  const onSubmit = async (data) => {
    try {
      await handleHelpRequest(data);
      reset();
      onClose();
    } catch (error) {
      console.error(error);
    }
  };

  const handleCancel = () => {
    reset();
    onClose();
  };

  const isFormValid = subject && description;

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <Box sx={{ display: 'flex', alignItems: 'end', mb: 2 }}>
        <DialogTitle>Contact Support</DialogTitle>
      </Box>
      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
        <Box sx={{ mt: 2, mx: 3, mb: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <RHFTextField label="Subject" name="subject" />
          <RHFTextField multiline rows={4} label="Description" name="description" />
        </Box>
        <Box sx={{ p: 2, display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
          <Button variant="outlined" onClick={handleCancel}>
            Cancel
          </Button>
          <LoadingButton type="submit" variant="contained" loading={isSubmitting} disabled={!isFormValid}>
            Send
          </LoadingButton>
        </Box>
      </FormProvider>
    </Dialog>
  );
}
